<template>
<div class="drawerWrap">
  <div class="drawerBody" v-if="this.handleType=='addAll'">
    <div class="downLoad">
      <span class="down" @click="downLoad">下载模板(Excel)</span>
      <span class="abnormalRecord" @click="abnormalRecord">异常记录</span>
    </div>
    <el-form ref="form" :model="form" :rules="formRules" :label-position="left" label-width="150px">
      <!-- <el-form-item label="组织机构" prop="orgId">
        <treeselect v-model="form.orgId" noResultsText="无匹配项" noOptionsText="暂无数据" :show-count="true" :disable-branch-nodes="false" :flat="true" :multiple="false" :defaultExpandLevel="Infinity" :options="optionsOrg" clearValueText="清除" clearable placeholder="请选择组织机构" :normalizer="normalizer"  />
      </el-form-item>
      <el-form-item label="通知人员类型" prop="noticeUserType">
        <el-select v-model="form.noticeUserType" placeholder="请选择报警和故障通知人员类型" clearable>
          <el-option v-for="item in optionsNoticeUserType" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="上传文件:">
        <el-upload drag :limit='limitNum' :auto-upload="false" :action="UploadUrl()" :before-upload="beforeUploadFile" :on-change="fileChange" :on-exceed="exceedFile" :on-success="handleSuccess" :on-error="handleError" :on-remove="handleRemove" :file-list="fileList">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传xlsx/xls文件，且不超过10M</div>
        </el-upload>
      </el-form-item>
    </el-form>
  </div>
  <div class="drawerBody" v-else>
    <el-form ref="form" :model="form" :rules="formRules" :label-position="left" label-width="150px">
      <el-form-item label="设备名称" prop="deviceName">
        <el-input v-model="form.deviceName" minlength="2" maxlength="20" placeholder="请输入设备名称"></el-input>
      </el-form-item>
      <el-form-item label="设备类型" prop="termtype">
        <el-select v-model="form.termtype" placeholder="请选择设备类型" clearable>
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
       <el-form-item label="组织机构" prop="orgId">
        <treeselect v-model="form.orgId" noResultsText="无匹配项" noOptionsText="暂无数据" :show-count="true" :disable-branch-nodes="false" :flat="true" :multiple="false" :defaultExpandLevel="Infinity" :options="optionsOrg" clearValueText="清除" clearable placeholder="请选择组织机构" :normalizer="normalizer"  />
      </el-form-item>
      <el-form-item label="是否启用" prop="isEnabled" v-if="handleType == 'edit'">
        <el-select v-model="form.isEnabled" placeholder="请选择启用方式" clearable>
          <el-option v-for="item in optionsEnable" :key="item.val" :label="item.name" :value="item.val"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="通知人员类型" prop="noticeUserType">
        <el-select v-model="form.noticeUserType" placeholder="请选择报警和故障通知人员类型" clearable>
          <el-option v-for="item in optionsNoticeUserType" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="IMEI" prop="imei">
        <el-input v-model="form.imei" maxlength="15"  placeholder="请输入设备IMEI号"></el-input>
      </el-form-item>
      <el-form-item label="推送地址" prop="deviceUrl">
        <el-input v-model="form.deviceUrl" minlength="2" maxlength="20" placeholder="请输入推送地址"></el-input>
      </el-form-item>
    </el-form>
  </div>
  <div class="drawerFoot">
    <el-button type="primary" @click="confirmHandle()" :loading="loading">{{ loading ? '提交中' : '提交' }}</el-button>
    <el-button @click="cancelHandle()">取 消</el-button>
  </div>
</div>
</template>

<script>
// var md5 = require("js-md5");
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: {
    Treeselect
  },
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    handleType: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      limitNum: 1, // 上传excell时，同时允许上传的最大数
      fileList: [], // excel文件列表
      radio: "1",
      left: "left",
      show: "添加",
      options1: [],
      optionsEnable:[
        {
          val:false,
          name:'禁用'
        },
        {
          val:true,
          name:'启用'
        }
      ],
      optionsNoticeUserType:[
        {
          id:1,
          name:'通知负责人'
        },{
          id:2,
          name:'通知安装人'
        },{
          id:3,
          name:'通知安装人和负责人'
        }
      ],
      options2: [{
          value: "NB",
          label: "NB"
        },
        {
          value: "LORA",
          label: "LORA"
        },
        {
          value: "TCP",
          label: "TCP"
        },
        {
          value: "UDP",
          label: "UDP"
        },
        {
          value: "MQTT",
          label: "MQTT"
        },
        {
          value: "TCP_GATEWAY",
          label: "TCP_GATEWAY"
        }
      ],
      options3: [{
          value: '0',
          label: "汉威通用协议"
        },
        {
          value: '1',
          label: "私有协议"
        },
        {
          value: '2',
          label: "完全透传"
        }
      ],
      options4: [{
          value: "DRX",
          label: "DRX"
        },
        {
          value: "PSM",
          label: "PSM"
        }
      ],
      options5: [{
          value: "dx",
          label: "DX"
        },
        {
          value: "It",
          label: "LT"
        },
        {
          value: "huawei",
          label: "HW"
        },
        {
          value: "ONENET",
          label: "ONENET"
        },
        {
          value: "CTWING",
          label: "DXctwing"
        }
      ],
      roleList: [],
      form: {
        deviceName: "",
        deviceUrl:"",
        // deviceCode: "",
        // heart: "",
        // termtypeid: "",
        // devicetypeid: "",
        // termtypecode:'',
        termtype:'',
        // communType: "",
        // protocolType: "",
        imei: "",
        isEnabled:'',
        noticeUserType:1,
        orgId:null,
        // ccid: "",
        // pattern: "",
        // operator: "",
        // imsi: '',
        // date1:[],
        // date2:[]
      },
      optionsOrg:[],
      formRules: {
        deviceName: [{
          required: true,
          validator: this.validateDeviceName,
          trigger: "blur"
        }],
        // deviceCode: [{
        //   required: true,
        //   validator: this.validateDeviceCode,
        //   trigger: "blur"
        // }],
        // heart: [{
        //   required: true,
        //   validator: this.validateHeart,
        //   trigger: "blur"
        // }],
        termtype:[
          {
          required: true,
          message:"设备类型为必填项",
          trigger: "change"
        }
        ],
        orgId:[{
          required: true,
          message:"组织机构为必填项",
          trigger: "change"
        }],
        noticeUserType:[{
          required: true,
          message:"通知人员类型为必填项",
          trigger: "change"
        }],
        // communType:[{
        //   required: true,
        //   message:"请选择协议类型",
        //   trigger: "change"
        // }],
        // protocolType:[{
        //   required: true,
        //   message:"请选择协议类型",
        //   trigger: "change"
        // }],
        // pattern:[{
        //   required: true,
        //   message:"请选择工作模式",
        //   trigger: "change"
        // }],
        // operator:[{
        //   required: true,
        //   message:"请选择运营商",
        //   trigger: "change"
        // }],
        imei: [{
          required: true,
          validator: this.validateImei,
          trigger: "blur"
        }],
        // ccid: [{
        //   required: true,
        //   validator: this.validateCcid,
        //   trigger: "blur"
        // }],
        // imsi: [{
        //   required: true,
        //   validator: this.validateImsi,
        //   trigger: "blur"
        // }]
      },
      isReuploadImg: false,
      resetPwd: false,
      imgPath: "",
      formData: {},
      appid: "",
      // getEditData: {},
      errorName: ''
    };
  },
  created() {
    // console.log(this.baseUrlAddr)
    console.log(this.handleType);
    // console.log(this.editData);      
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let par={
        page:1,
        pageSize:1000,
        isEnabled:true
      }
      this.request.post("/front/device/type/query",par).then(res => {
        console.log(res)
        if (res.code == 200) {
          this.options1=res.data.data;
        } else if (res.code == 500) {
          this.msg.warn(res.msg);
        }
      });
      if (this.handleType == 'add') {
        this.request.get(`/front/system/organization/findTreeById?id=0`)
        .then(rs => {
          console.log(rs);
          this.optionsOrg = rs.code === 200 ? rs.data : [];
          // this.form.orgId = this.optionsOrg.length > 0 ? this.optionsOrg[0].value : null;          
        })
        .catch(error => (this.optionsOrg = []));
        this.form.deviceName = "";
        this.form.deviceUrl = "";
        // this.form.heart = "";
        // this.form.termtypeid ="";
        // this.form.devicetypeid ="";
        // this.form.termtypecode ="";
        this.form.termtype="";
        // this.form.communType = "";
        // this.form.protocolType = "";
        this.form.imei = "";
        // this.form.ccid = "";
        // this.form.pattern = "";
        // this.form.operator = "";
        // this.form.date1 = "";
        // this.form.date2 = "";
      } else if (this.handleType == 'edit') { //编辑
        if (this.editData.id) {
          // this.request.get("/devstorage/findById", {
          //   id: this.editData.id
          // }).then(res => {
          //   console.log(res)
          //   if (res.code == 200) {
          //     this.getEditData = {
          //       ...res.data
          //     }
                this.form.deviceName = this.editData.name
                this.form.deviceUrl = this.editData.pushUrl
                // this.form.heart = this.getEditData.heartbeat;
                // this.form.termtypeid =this.getEditData.termtypeid;
                // this.form.termtypecode =this.getEditData.termtypecode;
                this.form.termtype=this.editData.typeId;
                // this.form.devicetypeid=this.getEditData.devicetypeid;
                // this.form.communType = this.getEditData.communtype
                // this.form.protocolType = this.getEditData.protocoltype
                this.form.imei = this.editData.imei
                this.form.isEnabled=this.editData.isEnabled
                this.form.noticeUserType=parseInt(this.editData.noticeUserType)
                this.request.get(`/front/system/organization/findTreeById?id=0`)
                .then(rs => {
                  console.log(rs);
                  this.optionsOrg = rs.code === 200 ? rs.data : [];  
                  this.form.orgId=this.editData.orgId? this.editData.orgId : null        
                })
                .catch(error => (this.optionsOrg = []));
                // this.form.ccid = this.getEditData.ccid
                // this.form.pattern = this.getEditData.pattern
                // this.form.operator = this.getEditData.operator
                // if(this.getEditData.simbdate!=null&&this.getEditData.simedate!=null){
                //   this.form.date1 = [this.getEditData.simbdate, this.getEditData.simedate]                 
                // }
                // if(this.getEditData.devicebDate!=null&&this.getEditData.deviceeDate!=null){
                //   this.form.date2 = [this.getEditData.devicebDate, this.getEditData.deviceeDate]                 
                // }
                
          //   }
          // })
        }
      }else if(this.handleType=="addAll"){
        this.request.get(`/front/system/organization/findTreeById?id=0`)
        .then(rs => {
          console.log(rs);
          this.optionsOrg = rs.code === 200 ? rs.data : [];
          // this.form.orgId = this.optionsOrg.length > 0 ? this.optionsOrg[0].value : null;          
        })
        .catch(error => (this.optionsOrg = []));
      }
    },
    cancelHandle() {
      //取消
      this.$emit("cancel", false);
    },
    confirmHandle() {
      //确认
      // let formDates = {
      //   name: this.form.deviceName,
      //   pushUrl: this.form.deviceUrl,
      //   typeId:this.form.termtype,
      //   imei: this.form.imei,
      //   orgId:this.form.orgId?this.form.orgId:0,   
      //   noticeUserType: this.form.noticeUserType
      // }
      if (!this.fileList.length && this.handleType == 'addAll') {
        return this.msg.error("用户必须上传文件!");
      }
      this.$refs["form"].validate(valid => {
        if (!valid) {
          return this.msg.error("请按要求完善表单信息");
        }
        this.$emit("update:loading", true);
        if (this.handleType == 'add') {
          this.request.post("/front/device/add", formDates).then(res => {
            console.log(res);
            if (res.code == 200) {
              this.$emit('confirm', res.code)
              this.msg.success("设备添加成功");
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
            }
            this.$emit("update:loading", false)
          });
        } else if (this.handleType == 'edit') {
          let source = {
            id:this.editData.id,
            isEnabled: this.form.isEnabled,
          }
          let editDatas = Object.assign(formDates, source);
          // console.log(editDatas)
          delete editDatas.typeId
          this.request.post("/front/device/update", editDatas).then(res => {
            console.log(res);
            if (res.code == 200) {
              this.$emit('confirm', res.code)
              this.msg.success("设备信息修改成功");
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
            }
            this.$emit("update:loading", false)
          });
        } else if (this.handleType == 'addAll') {
          var formData = new FormData()
          // console.log(this.fileList[0])
          formData.append('file', this.fileList[0])
          this.request.postParamsForm("/front/device/instalBatch", {}, formData).then(res => {
            console.log(res)
            if (res.code == 200) {
                this.$emit('confirm', res.code)
                this.msg.success("提交成功");
            } else {
              // this.msg.warn(res.msg);
                this.msg.warn(res.msg+ ",请点击异常记录进行下载查看！");
                this.errorName = res.data
            }
            this.$emit("update:loading", false)
          })
        }
        // this.$emit("confirm", this.form);
        //   this.storage.setSession("headImg", this.form.img);
      });
    },
    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$message.warning(
        // `只能上传 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`
        `只能上传 ${this.limitNum} 个文件`
      );
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      //      console.log(file,fileList);
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      //    console.log(extension);

      if (extension !== 'xls' && extension !== 'xlsx') {
        this.fileList.shift();
        return this.$message.warning('上传模板只能是 xls、xlsx格式!')
      }
      let size = file.size / 1024 / 1024;
      if (size > 10) {
        this.fileList.shift();
        return this.$message.warning("文件大小不得超过10M");
      }
      this.fileList.push(file.raw)
      // console.log(this.fileList);
    },
    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile(file) {
      //   console.log('before upload');
      console.log(file);
      // const extension = file.name.split('.')[1] === 'xls'
      // const extension2 = file.name.split('.')[1] === 'xlsx'
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (extension !== 'xls' && extension !== 'xlsx') {
        this.$message.warning('上传模板只能是 xls、xlsx格式!')
      }
      let size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message.warning("文件大小不得超过10M");
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      this.$message.success("文件上传成功");
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      //   console.log(file, fileList);
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$message.error("文件上传失败");
    },
    UploadUrl: function () {
      // 因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，所以这里将action设置为一个返回为空的方法就行，避免抛错
      return "";
    },
    uploadFile() {
      if (this.fileList.length === 0) {
        this.$message.warning("请上传文件");
      } else {
        let formData = new FormData();
        //  console.log(this.fileList)
        for (const key in this.fileList[0]) {
          formData.append(key, this.fileList[0][key]);
        }
        // formData.append('file', this.fileList);
        //  console.log(formData)
        this.formData = formData;
        //  console.log(this.formData)
      }
    },
    //验证规则
    validateDeviceName(rule, value, callback) {
      if (value === "") {
        callback(new Error("设备名称为必填项"));
      } else if (value.length > 20) {
        callback(new Error("名称长度不能超过20个字符"));
      } else {
        // else if (value.length < 2) {
        //    callback(new Error("名称长度不能少于2个字符"));
        // }
        var reg = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]");
        if (reg.test(value)) {
          callback(
            new Error("名称不合法,设备名称中不能包含特殊符号！")
          );
        } else {
          callback();
        }
      }
    },
    validateDeviceCode(rule, value, callback) {
      if (value === "") {
        callback(new Error("编码不能为空"));
      } else if (value.length > 12) {
        callback(new Error("编码长度必须为12个字符"));
      } else if (value.length < 12) {
        callback(new Error("编码长度必须为12个字符"));
      } else {
        var reg = new RegExp(/^[0-9a-zA-Z]*$/);
        if (!reg.test(value)) {
          callback(new Error("编码不合法,请输入由英文(a-z/A-Z)或数字组成的编码！"));
        } else {
          callback();
        }
      }
    },
    validateHeart(rule, value, callback) {
      if (value === "") {
        callback(new Error("心跳间隔不能为空"));
      } else if (value.length > 6) {
        callback(new Error("心跳间隔时间长度不能超过6个字符"));
      } else {
        var reg = new RegExp(/^([0-9]*)$/);
        if (!reg.test(value)) {
          callback(new Error("心跳间隔格式不合法,请输入正整数作为心跳间隔时间！"));
        } else {
          callback();
        }
      }
    },
    validateImei(rule, value, callback) {
      if (value === "") {
        callback(new Error("IMEI为必填项"));
      } else if (value.length > 15) {
        callback(new Error("IMEI长度必须是15个字符"));
      } else if (value.length < 15) {
        callback(new Error("IMEI长度必须是15个字符"));
      } else {
        var reg = new RegExp("^[A-Za-z0-9]+$");//new RegExp(/^([0-9]*)$/);
        if (!reg.test(value)) {
          callback(new Error("IMEI不合法,请输入由数字字母组成的IMEI！"));
        } else {
          callback();
        }
      }
    },
    validateImsi(rule, value, callback) {
      if (value === "") {
        callback(new Error("IMSI不能为空"));
      } else if (value.length > 15) {
        callback(new Error("IMSI长度不能超过15个字符"));
      } else {
        var reg = new RegExp(/^([0-9]*)$/);
        if (!reg.test(value)) {
          callback(new Error("IMSI不合法,请输入由数字组成的IMSI！"));
        } else {
          callback();
        }
      }
    },
    validateCcid(rule, value, callback) {
      if (value === "") {
        callback(new Error("CCID不能为空"));
      } else if (value.length > 20) {
        callback(new Error("CCID长度必须为20个字符"));
      } else if (value.length < 20) {
        callback(new Error("CCID长度必须为20个字符"));
      } else {
        var reg = new RegExp(/^[0-9a-zA-Z]*$/);
        if (!reg.test(value)) {
          callback(new Error("CCID不合法,请输入由英文字符或数字组成的CCID！"));
        } else {
          callback();
        }
      }
    },
    //转换时间
    timefilters(val) {
      if (val == null || val == "") {
        return "暂无时间";
      } else {
        let d = new Date(val); //val 为表格内取到的后台时间
        let month =
          d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times = d.getFullYear() + "-" + month + "-" + day;
        return times;
      }
    },
    abnormalRecord() { //异常记录
      console.log(this.errorName)
      if (this.errorName != '') {
        window.open(this.baseUrlAddr + '/front/device/deviceBatchInstallErrInfo?fileName=' + this.errorName)
      } else {
        this.msg.warn("无异常记录")
      }
    },
    downLoad() { //下载excel模板
      window.open(this.baseUrlAddr +'/front/device/deviceBatchInstallTemplate')
    },
     //树形结构
    normalizer(node){
      console.log(node);
      
      //去掉children=null的属性
      if(node.children==null||node.children=='null'){
        delete node.children;
      }
      return {
        id: node.value,
        label: node.label,
        children: node.children&&node.children.length?node.children:'',
        isDisabled: node.id==0? true : false
      };
  },
  }
};
</script>

<style lang="scss" scoped>
.drawerWrap {
  .drawerBody {
    .downLoad {
      margin-top: 20px;
      color: #6e6e6e;
      font-size: 14px;
      line-height: 28px;
      font-weight: 400;
      padding-left: 20px;
      .down {
        cursor: pointer;
        border-bottom: 1px solid #6e6e6e;
      }

      .abnormalRecord {
        margin-left: 10px;
        cursor: pointer;
        border-bottom: 1px solid #6e6e6e;
      }
    }
  }
}
</style><style lang="scss">
.drawerWrap {
  .el-transfer {
    .el-transfer-panel {
      text-align: left;
      width: 250px;
    }

    .el-transfer__buttons {
      width: 65px;
      text-align: center;

      .el-button {
        margin: 5px 0;
        width: 56px;
      }
    }
  }

  .el-switch {
    width: 100%;
  }

  .el-image {
    margin-right: 20px;
  }

  .el-form {
    margin-top: 20px;

    .el-form-item__label {
      line-height: 50px;
    }

    .el-form-item__content {
      line-height: 50px;

      .el-col-2 {
        // width: 8.33333%;
        text-align: center !important;
      }

      .el-date-editor--daterange.el-input__inner {
        width: 270px;
      }

      .el-date-editor--date {
        // display: inline-block;
        // width: 128px;
      }
    }

    .el-select {
      width: 100%;
    }

    .el-textarea {
      width: 270px;

      .el-textarea__inner {
        height: 100px !important;
        line-height: 20px;
        color: #6e6e6e;
        font-size: 14px;
      }
    }

    .el-input {
      width: 270px;

      .el-input__inner {
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .drawerBody .el-form-item__label,
  .sp {
    color: #6e6e6e;
  }
  .drawerBody{
     .vue-treeselect{
      width:270px;
      margin-top: 5px;
      .vue-treeselect__control{
        div{
          line-height: 40px;
          height: 40px;
        }
      }
    }
  }
}
</style>
